const fetchFileAsBlob = async (urlWithSASToken) => {
    try {
      const response = await fetch(urlWithSASToken);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.blob();
    } catch (error) {
      console.error("Error fetching file:", error);
      throw error;
    }
  };
  
  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () =>{
        let base64Image = reader.result;

        if (base64Image && base64Image.startsWith("data:")) {
            base64Image = base64Image.split(",")[1];
          }
        resolve(base64Image)
        
        };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(blob);

     
    });
  };
  
  const getFileAsBase64 = async (urlWithSASToken) => {
    try {
      const fileBlob = await fetchFileAsBlob(urlWithSASToken);
      return await convertBlobToBase64(fileBlob);
    } catch (error) {
      console.error("Error fetching or converting file:", error);
      throw error;
    }
  };
  
  export default getFileAsBase64;